export enum EditActionType {
  ADD_VERTEX,
  EDIT_VERTEX,
  REMOVE_VERTEX,
  UPDATE_PATHS, // when all vertices are updated at once, e.g. when dragging
  UNDO,
  REDO,
  CANCEL, // undoes everything + resets revert state
  RESET,
}

export default EditActionType;
